
__webpack_require__.debugRequireIds = {
	"-!./debug-require.cjs": 2800,
	"./debug-require.cjs": 27581,
	"./src/base_page_params.ts": 3698,
	"./src/blueslip.ts": 67040,
	"./src/blueslip_stacktrace.ts": 33622,
	"./src/bot_types.ts": 23603,
	"./src/bundles/common.ts": 35013,
	"./src/bundles/legacy_portico_bundle.ts": 85291,
	"./src/csrf.ts": 1156,
	"./src/loading_error.ts": 57553,
	"./src/portico/google-analytics.ts": 75781,
	"./src/portico/legacy_header.ts": 70610,
	"./src/portico/portico_modals.ts": 91076,
	"./src/portico/tippyjs.ts": 27294,
	"./src/realm_user_settings_defaults.ts": 26646,
	"./src/retry_backoff.ts": 42797,
	"./src/sentry.ts": 333,
	"./src/state_data.ts": 80096,
	"./src/stream_types.ts": 2036,
	"./src/types.ts": 51441,
	"./src/user_settings.ts": 24729,
	"./src/user_status_types.ts": 10264,
	"./styles/portico/collaborychat_auth.css": 7817,
	"./templates/blueslip_stacktrace.hbs": 97825,
	"@sentry/conventions/attributes": 59966,
	"core-js/modules/es.array.includes.js": 54508,
	"core-js/modules/es.array.push.js": 94361,
	"core-js/modules/es.iterator.constructor.js": 16608,
	"core-js/modules/es.iterator.find.js": 70001,
	"core-js/modules/es.iterator.map.js": 72542,
	"core-js/modules/es.json.parse.js": 9999,
	"core-js/modules/es.json.stringify.js": 27761,
	"core-js/modules/es.map.get-or-insert-computed.js": 47180,
	"core-js/modules/es.map.get-or-insert.js": 40870,
	"error-stack-parser": 69363,
	"ga-gtag": 78406,
	"handlebars/runtime.js": 38417,
	"jquery": 63150,
	"micromodal": 94456,
	"minimalistic-assert": 45185,
	"source-map": 68068,
	"stackframe": 36854,
	"stacktrace-gps": 14021,
	"tippy.js": 99947,
	"tippy.js/dist/tippy.css": 81988
};